export const Evelyn_Device_Points_Config = {
  L1_SWITCH: {
    shape: 'switch',
    internalId: 'L1_SWITCH',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    label: '89-L1',
    points: [
      {
        label: '89-L1 Switch Status',
        pointName: '87T1_BU_SW_89_M1_CLOSED',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  L1_BREAKER: {
    shape: 'breaker',
    internalId: 'L1_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-L1',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-L1 Breaker Status',
        pointName: '11_L1_GCB_52L1_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: '52-L1 Frequency',
        pointName: 'MET_L1_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-L1 VAB',
        pointName: 'MET_L1_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-L1 IA',
        pointName: 'MET_L1_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-L1 P Watts',
        pointName: 'MET_L1_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-L1 Q Vars',
        pointName: 'MET_L1_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F1_BREAKER: {
    shape: 'breaker',
    internalId: 'F1_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-F1',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-F1 Breaker Status',
        pointName: '11_F1_VCB_52F1_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: 'Frequency',
        pointName: 'MET_F1_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: 'VAB',
        pointName: 'MET_F1_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: 'IA',
        pointName: 'MET_F1_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: 'P Watts',
        pointName: 'MET_F1_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Q Vars',
        pointName: 'MET_F1_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F2_BREAKER: {
    shape: 'breaker',
    internalId: 'F2_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-F2',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-F2 Breaker Status',
        pointName: '11_F2_VCB_52F2_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: '52-F2 Frequency',
        pointName: 'MET_F2_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F2 VAB',
        pointName: 'MET_F2_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F2 IA',
        pointName: 'MET_F2_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F2 P Watts',
        pointName: 'MET_F2_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F2 Q Vars',
        pointName: 'MET_F2_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F3_BREAKER: {
    shape: 'breaker',
    internalId: 'F3_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-F3',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-F3 Breaker Status',
        pointName: '11_F3_VCB_52F3_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: '52-F3 Frequency',
        pointName: 'MET_F3_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F3 VAB',
        pointName: 'MET_F3_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F3 IA',
        pointName: 'MET_F3_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F3 P Watts',
        pointName: 'MET_F3_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F3 Q Vars',
        pointName: 'MET_F3_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F4_BREAKER: {
    shape: 'breaker',
    internalId: 'F4_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-F4',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-F4 Breaker Status',
        pointName: '11_F4_VCB_52F4_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: '52-F4 Frequency',
        pointName: 'MET_F4_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F4 VAB',
        pointName: 'MET_F4_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F4 IA',
        pointName: 'MET_F4_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F4 P Watts',
        pointName: 'MET_F4_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F4 Q Vars',
        pointName: 'MET_F4_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F5_BREAKER: {
    shape: 'breaker',
    internalId: 'F5_BREAKER',
    dataSourceDeviceType: 'rtac',
    label: '52-F5',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: '52-F5 Breaker Status',
        pointName: '11_F5_VCB_52F5_CLOSE',
        isStatusBinaryPoint: true,
      },
      {
        label: '52-F5 Frequency',
        pointName: 'MET_F5_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F5 VAB',
        pointName: 'MET_F5_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F5 IA',
        pointName: 'MET_F5_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F5 P Watts',
        pointName: 'MET_F5_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: '52-F5 Q Vars',
        pointName: 'MET_F5_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  AUXILIARY_FEED: {
    shape: 'auxiliary feed',
    internalId: 'AUXILIARY_FEED',
    dataSourceDeviceType: 'rtac',
    label: '',
    dataSourceDeviceEngineeringId: 'rtac_sub',
    points: [
      {
        label: 'Auxiliary Frequency',
        pointName: 'MET_BA_FREQ',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Auxiliary VAB',
        pointName: 'MET_BA_VAB',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Auxiliary IA',
        pointName: 'MET_BA_IA',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Auxiliary P Watts',
        pointName: 'MET_BA_P_WATTS',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Auxiliary Q Vars',
        pointName: 'MET_BA_Q_VARS',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
};
